import { Box, Modal, Typography } from '@mui/material';

type CustomModalProps = {
    isModalOpen: boolean;
    shouldDisplayCloseBtn: boolean;
    shouldDisplayValidateBtn: boolean;
    handleOnClose: () => void;
    title: React.ReactNode;
    content: any;
};

function CustomModal(props: CustomModalProps) {
    const { isModalOpen, title, content, handleOnClose } = props;
    return (
        <Modal open={isModalOpen} onClose={handleOnClose}>
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    overflow: 'auto',
                    borderRadius: 3,
                    padding: 2,
                    backgroundColor: 'background.paper',
                    overflowX: 'hidden',
                    minHeight: '25%',
                    maxHeight: '75%',
                    minWidth: { xs: '85%', sm: '50%' },
                    maxWidth: { xs: '90%', sm: '75%' },
                    margin: 0,
                }}>
                <Box>
                    <Typography
                        id='modal-modal-title'
                        variant='h5'
                        component='h2'
                        padding={2}>
                        {title}
                    </Typography>
                </Box>
                {content}
            </Box>
        </Modal>
    );
}

export default CustomModal;
